import { FC } from 'react';

import { useCart } from '../../../lib/context/cart/CartContext';
import { MealListItem } from '../MealListItem';
import { Button } from '../../atoms/Button';
import { CloseIcon } from '../../atoms/icons/CloseIcon';
import { CartIcon } from '../../atoms/icons/CartIcon';
import type { CartComponentProps } from './CartComponent.types';

import styles from './CartComponent.module.css';
export const CartComponent: FC<CartComponentProps> = ({ deliveryDate, onCloseCart }) => {
    const { getCartCount, cart, eraseCart } = useCart();
    const cartCount = getCartCount();

    const getTitleFormatted = () => {
        const date = new Date(deliveryDate as string);
        const formatter = new Intl.DateTimeFormat('en-US', {
            weekday: 'long',
            month: 'short',
            day: 'numeric'
        });

        return formatter.format(date);
    }

    const handleClearCart = () => {
        eraseCart();
    }

    return (
        <div className={styles.cartComponentModal}>
            <header className={styles.header}>
                <div className={styles.title}>
                    <CartIcon />
                    {deliveryDate && (
                        <p>
                            {getTitleFormatted()}
                        </p>
                    )}
                </div>
                <div className={styles.actions}>
                    <Button onClick={onCloseCart}>
                        <CloseIcon />
                    </Button>
                </div>
            </header>
            <div>
                <div className={styles.cartComponentTitle}>
                    <p>
                        {cartCount} {cartCount === 1 ? 'meal' : 'meals'}
                    </p>
                    <Button className={styles.clear} onClick={handleClearCart}>
                        Clear cart
                    </Button>
                </div>
            </div>
            <div className={styles.cartComponent}>
                {cart?.length > 0 && (
                    cart?.map((meal) =>
                        <MealListItem key={meal.id} data={meal} />
                    )
                )}
            </div>
        </div>
    );
};